import { Component, OnInit ,Inject, EventEmitter, Input, Output, ElementRef, OnDestroy, OnChanges, ViewChild } from '@angular/core';

import { animate, keyframes, state, style, transition, trigger } from '@angular/animations/animations';
import { RestaurantItem } from 'src/app/models/restaurant';
import { DeletedInnerMenus, Ingredient, IngredientClass, IngredientSave, IngredientSaveClass, Set, SetClass, SetsList, SetsSave, SetsSaveClass } from 'src/app/models/setsMoal';
import { OrdersService } from 'src/app/services/order-service';
import { AppProxy } from 'src/app/services/app-proxy';
import { flatten } from '@angular/compiler';
import { setLines } from '@angular/material/core';

@Component({
  selector: 'app-popup-additionsSet',
  templateUrl: './popup-additionsSet.component.html',
  styleUrls: ['./popup-additionsSet.component.scss'],     animations: [
    trigger('slideUp', [
      state('void', style({ 
        transform: 'translateY(100%)',
        opacity: 0
      })),
      state('open', style({ 
        transform: 'translateY(0)',
        opacity: 1
      })),
      state('closing', style({ 
        transform: 'translateY(100%)',
        opacity: 0
      })),
      transition('void => open', [
        animate('300ms cubic-bezier(0.4, 0, 0.2, 1)')
      ]),
      transition('open => closing', [
        animate('300ms cubic-bezier(0.4, 0, 0.2, 1)')
      ])
    ]),
    trigger('fadeImage', [
      state('hidden', style({ opacity: 0 })),
      state('visible', style({ opacity: 1 })),
      transition('hidden <=> visible', animate('300ms ease-in-out'))
    ]),

    trigger('shakeAnimation', [
      state('normal', style({})),
      state('shake', style({})),
      transition('normal <=> shake', [
        animate('0.6s', keyframes([
          style({ transform: 'translateX(0)', offset: 0 }),
          style({ transform: 'translateX(-10px)', offset: 0.2 }),
          style({ transform: 'translateX(0px)', offset: 0.4 }),
          style({ transform: 'translateX(-10px)', offset: 0.6 }),
          style({ transform: 'translateX(0px)', offset: 0.8 }),
          style({ transform: 'translateX(0)', offset: 1 })
        ]))
      ])
    ]),

    trigger('nestedSetAnimation', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateY(-10px)' }),
        animate('500ms cubic-bezier(0.2,0,0.2,1)', style({ opacity: 1, transform: 'translateY(0)' }))
      ]),
      transition(':leave', [
        animate('400ms', style({ opacity: 0, transform: 'translateY(-20px)' }))
      ])
    ])
  ]
})
export class PopupAdditionsSetComponent implements OnChanges,  OnDestroy {
  static openPopups = 0;
  @Input() isOpen = false;
  @Input() dish: RestaurantItem;
  @Input() isFromEdit = false;
  @Input() menuId?: number = 0;
  @Input() countNumber?: number;
  @Input() parentOrderListID?: number;
  @Input() parentCountNumber?: number;
  @Input() dishSetID?: number;
  @Input() ingredientID?: number;
  @Input() ingredientName?: string;
  @Input() ingredientPrice?: string;
  @Input() restaurantID?: number;

  @Output() close = new EventEmitter<void>();
  @Output() saveSet = new EventEmitter<void>();

  @ViewChild('nameLine') nameLineRef: ElementRef;
  @ViewChild('popupOverlay') popupOverlayRef: ElementRef;
  nameLineDisplay = 'none';
  animationState: 'void' | 'open' | 'closing' = 'void';

  checkBoxImgOn='assets/images/Extras_Popup_Chack_Box_On.png';
  checkBoxImgOff ='assets/images/Extras_Popup_Chack_Box_Off.png';  

  infoId = 0;
  lastParentSetID = 0
  countDish = 1
  myDesignPrice: string 
  myTotalPrice = 0
  setsList: SetsList;
  setsSave : SetsSave[] = [];
  deletedNestedMenus: DeletedInnerMenus[] = [];
  private readonly DRAG_THRESHOLD = 100; // Pixels needed to trigger close
  private dragStartY = 0;
  private currentDragY = 0;
  private isDragging = false;

  private boundMouseMove: any;
  private boundMouseUp: any;
  private boundTouchMove: any;
  private boundTouchEnd: any;
  totalPrice : string 
  imageVisible = false;
  divVisible = false;
  nestedPopupOpen = false;
  nestedPopupParams: any = null;
  ingredientsArrName: string = '';
  isChangeOnFood = false;
  constructor(private elementRef: ElementRef ,private orderService:OrdersService) {
    // Bind the methods to preserve 'this' context
    this.boundMouseMove = this.onDrag.bind(this);
    this.boundMouseUp = this.onDragEnd.bind(this);
    this.boundTouchMove = this.onDrag.bind(this);
    this.boundTouchEnd = this.onDragEnd.bind(this);
  }
  

    privateIsFromEdit = false
   iconSize = 0; 

      // Method to update circle size dynamically (e.g., from an input)
      updateCircleSize(newRadius: number): void {
        this. iconSize = newRadius;
      }


get checkmarkPathD(): string {
  // Original Figma viewBox: 32x32 (since your path fits this box)
  const scaleX = this.iconSize / 32;
  const scaleY = this.iconSize / 32;

  const p = [
    { x: 8.8, y: 16.2 },
    { x: 10.2, y: 17.2 },
    { x: 13.0, y: 19.9 },
    { x: 14.2, y: 21.8 },
    { x: 15.6, y: 18.8 },
    { x: 19.0, y: 12.2 },
    { x: 22.7, y: 9.2 }
  ];

  return `M${(p[0].x * scaleX).toFixed(3)} ${(p[0].y * scaleY).toFixed(3)}C` +
    `${(p[1].x * scaleX).toFixed(3)} ${(p[1].y * scaleY).toFixed(3)} ` +
    `${(p[2].x * scaleX).toFixed(3)} ${(p[2].y * scaleY).toFixed(3)} ` +
    `${(p[3].x * scaleX).toFixed(3)} ${(p[3].y * scaleY).toFixed(3)}C` +
    `${(p[4].x * scaleX).toFixed(3)} ${(p[4].y * scaleY).toFixed(3)} ` +
    `${(p[5].x * scaleX).toFixed(3)} ${(p[5].y * scaleY).toFixed(3)} ` +
    `${(p[6].x * scaleX).toFixed(3)} ${(p[6].y * scaleY).toFixed(3)}`;
}
  contentLoaded = false;
  async ngOnChanges() {
const isMobile = window.innerWidth < 768;
  const screenWidth = isMobile ? '100vw' : '46.41vh';
  document.documentElement.style.setProperty('--screen-width', screenWidth);
this.updateCircleSize(28.76 * window.innerWidth /500 * (isMobile ? 1 : 0.4641));
 if (this.isOpen) {
    this.imageVisible = false;
    this.divVisible = true;
    this.contentLoaded = false;
    this.detectIOSAndSetupSafeArea();
    this.setupViewportListener();
    PopupAdditionsSetComponent.openPopups++;
    document.body.style.overflow = 'hidden';


      this.countDish = 1
         if (this.dish) {
      this.myDesignPrice = "₪" + (Number(this.dish.Price)).toFixed(2);

      if (this.dish.IsAddition == 0) {
        this.myTotalPrice = Number(this.dish.Price);
        this.totalPrice = this.formatPrice(Number(this.dish.Price * this.countDish));
      }
    }
      

    await this.loadSets();

    // If dish is missing, try to fill from setsList
    if (!this.dish && this.ingredientPrice) {
      this.myDesignPrice =  
       "₪" + (Number(this.ingredientPrice)).toFixed(2) ;
    }
  
    this.openPopUp();

    
  } else {
   
     PopupAdditionsSetComponent.openPopups = Math.max(0, PopupAdditionsSetComponent.openPopups - 1);
     document.body.style.overflow = ''
     
    // Start closing animation
    // this.animationState = 'closing';
    // this.imageVisible = false;
  }
  }

  onAnimationDone(event: any) {
    // if (event.toState === 'closing') {
    //   this.divVisible = false;
    //   this.animationState = 'void';
    // }
  }
 


  onScroll(event: any) {
  const x = this.elementRef.nativeElement.querySelector('#image2');
  // Use the ViewChild reference for nameLine
  const y = this.nameLineRef?.nativeElement;
  if (!x || !y) return;

  if ((1 - (event.target.scrollTop / x.offsetHeight)) <= 0) {
    this.nameLineDisplay = 'block';
    return;
  }
  if (event.target.scrollTop > x.offsetHeight / 2) {
    this.nameLineDisplay = 'none';
    x.style.opacity = String(1 - (event.target.scrollTop / x.offsetHeight));
  } else {
    x.style.opacity = '1.0';
  }
}

   private async loadSets() {
let setsList: SetsList;
  if (this.menuId && this.menuId > 0) {
    
    // Nested popup: use menuId and other params
      setsList = await this.orderService
      .getSets(this.menuId, this.countNumber, this.parentOrderListID, this.parentCountNumber, this.dishSetID, this.ingredientID)
      .toPromise();
  
  } else {
     setsList = await this.orderService
      .getSets(localStorage.MENU_ID, localStorage.MENU_NUMBER)
      .toPromise();
  }
 this.setsList = setsList;
  this.loadHederSets(this.setsList.list);
  this.privateIsFromEdit = false;
  this.checkOpenNestedPopup(this.setsList.list);
}
   


  private loadHederSets(myListSet : Set[])
  {
    for (let set of  myListSet)
      {

         //מיועד לחישוב המחיר אם מגיע מעדכון
        this.privateIsFromEdit =this.isFromEdit


        let totalSelected = this.setTextForRequired(set)


        // אם מגיע מעדכון
        //  צריך לעדכן את המחירים ואת הכותרות של הסטים הפנימיים
         if (this.privateIsFromEdit)
         {
          let countSelected = 0
         for (let ingredient  of  set.Ingredients)
         {

          if (countSelected >= totalSelected)
          {
            break
          }
            if (ingredient.SelectedCount > 0 )
            {
              countSelected ++
              if ( ingredient.internalSets.length > 0)
            {
              this.loadHederSets(ingredient.internalSets)

            }
          }
         }
         }
      
      }

  }

  private openNestedPopup(ingredient: Ingredient, parentSet: Set): void {
  this.nestedPopupParams = {
    menuId: ingredient.internalSets[0].MenuID,
    countNumber: ingredient.internalSets[0].DealMenu?.CountNumber || 1,
    parentOrderListID: this.setsList.OrderListID,
    parentCountNumber:this.setsList.CountNumber,
    dishSetID: parentSet.ID,
    ingredientID: ingredient.ID,
    ingredientName: ingredient.internalSets[0].SetName,
    ingredientPrice: Number(ingredient.Price) > 0 ? ingredient.Price : ''
  };
  this.isChangeOnFood = ingredient.DealOrderMenu != null && ingredient.DealOrderMenu.ID > 0;
  this.nestedPopupOpen = true;
}
  //אם יש מנת דיל פתוחה שאינה מאושרת
  private checkOpenNestedPopup( setsList: Set[]) {
   for (let set of setsList) {
      if (set.Ingredients && set.Ingredients.length > 0) {
        for (let ingredient of set.Ingredients) {
          if (ingredient.internalSets 
            && ingredient.internalSets.length > 0 
            && ingredient.DealOrderMenu 
            && ingredient.DealOrderMenu.ID > 0 
            && ingredient.SelectedCount == 0 
            && ingredient.DealOrderMenu[0]?.Ingredients.length > 0) {
           this.openNestedPopup(ingredient, set);
          
            return;
          }
        }
      }
    }
   
  }
  clearComments() {
    this.setsList.Comments = '';
    // Reset textarea height to one line
    const textarea = document.querySelector('.CommentsDishInput') as HTMLTextAreaElement;
    if (textarea) {
      textarea.style.height = '4.532vh';
    }
  }

autoGrowTextZone(e: any) {

  
  const textarea = e.target;

  // Reset height to calculate accurate scrollHeight
  textarea.style.height = '5vh';

  // Convert 9.06vh to pixels
  const maxHeightPx = window.innerHeight * 0.0906;

  // If content exceeds two lines
  if (textarea.scrollHeight > textarea.offsetHeight) {
    const lines = textarea.value.split('\n');
    if (lines.length > 2) {
      textarea.value = lines.slice(0, 2).join('\n');
    }
    // Now compare scrollHeight to 9.06vh in pixels
    else if (textarea.scrollHeight > maxHeightPx) {
      textarea.value = textarea.value.slice(0, -1);
    }

    textarea.style.height = '10vh';
  }
}


// פונקציות להורדה של הפופ אפ באנימציה
//__________________________________________________________________
  ngOnDestroy() {
    PopupAdditionsSetComponent.openPopups = Math.max(0, PopupAdditionsSetComponent.openPopups - 1);
    if (PopupAdditionsSetComponent.openPopups === 0) {
    document.body.style.overflow = '';
    this.removeGlobalEventListeners();
    }
  }

  onDragStart(event: MouseEvent | TouchEvent) {
    if (event instanceof MouseEvent && event.button !== 0) return; 
    
    this.isDragging = true;
    this.dragStartY = this.getEventY(event);
    
    const overlay = this.elementRef.nativeElement.querySelector('.popup-conta');
    if (overlay) {
      overlay.style.transition = 'none';
    }


    if (event instanceof MouseEvent) {
      window.addEventListener('mousemove', this.boundMouseMove);
      window.addEventListener('mouseup', this.boundMouseUp);
    } else {
      window.addEventListener('touchmove', this.boundTouchMove);
      window.addEventListener('touchend', this.boundTouchEnd);
    }
  }





  onDrag(event: MouseEvent | TouchEvent) {
    if (!this.isDragging) return;
    event.preventDefault();
    
    const currentY = this.getEventY(event);
    const deltaY = currentY - this.dragStartY;
    
    if (deltaY > 0) {
      this.currentDragY = deltaY;
      const overlay = this.elementRef.nativeElement.querySelector('.popup-conta');
      const header = this.elementRef.nativeElement.querySelector('.row-header');
      
      if (overlay && header) {
        overlay.style.transform = `translateY(${deltaY}px)`;
       // header.style.transform = `translateY(${deltaY}px)`;
      }
    }
  }




 
  onDragEnd() {
    if (!this.isDragging) return;
    
    this.isDragging = false;
    this.removeGlobalEventListeners();

    const overlay = this.elementRef.nativeElement.querySelector('.popup-conta');
    
    if (overlay) {
      if (this.currentDragY > this.DRAG_THRESHOLD) {
        
        this.closePopupFromPosition(this.currentDragY);
      } else {
        overlay.style.transition = 'transform 0.3s ease-out';
        overlay.style.transform = 'translateY(0)';
        this.currentDragY = 0;
      }
    }
  }

  closePopupFromPosition(startY: number) {
    const overlay = this.elementRef.nativeElement.querySelector('.popup-conta');
    const windowHeight = window.innerHeight;
    

    overlay.style.transition = 'none';
  
    overlay.style.transform = `translateY(${startY}px)`;
    
    
    overlay.offsetHeight;
    

    overlay.style.transition = 'transform 0.3s ease-out';
    overlay.style.transform = `translateY(${windowHeight}px)`;
   
    setTimeout(() => {
      this.close.emit();
    }, 300);
  }

  closePopup() {
    
   
    this.animationState = 'closing';
    this.imageVisible = false;
    setTimeout(() => {
      this.close.emit();
     
    }, 300); // Match animation duration
  }

  openPopUp() {
    this.contentLoaded = true;
    this.animationState = 'open';
    this.imageVisible = true;
    setTimeout(() => {
     
    }, 300); // Match animation duration
  }




  private removeGlobalEventListeners() {
    window.removeEventListener('mousemove', this.boundMouseMove);
    window.removeEventListener('mouseup', this.boundMouseUp);
    window.removeEventListener('touchmove', this.boundTouchMove);
    window.removeEventListener('touchend', this.boundTouchEnd);
    window.removeEventListener('resize', this.updateSafeAreaOnResize.bind(this));
    window.removeEventListener('orientationchange', this.updateSafeAreaOnResize.bind(this));
  }

  private getEventY(event: MouseEvent | TouchEvent): number {
    return event instanceof MouseEvent ? event.clientY : event.touches[0].clientY;
  }

  preventBackdropClick(event: MouseEvent) {
    event.stopPropagation();
  }
//__________________________________________________________________
   

  countDishClick(signal:boolean)
  {

   if  (signal == true)
    {
      this.countDish += 1
    }
  
  else
  {
    if (this.countDish > 1)
      {
        this.countDish -= 1
          
      }
  }
  this.totalPrice = this.formatPrice(Number(this.myTotalPrice * this.countDish));
 }

  toggleIngredient(ingredient: Ingredient, parentSet: Set) {
    
    const currentCount = ingredient.SelectedCount || 0;
   const newCount = currentCount === 0 ? 1 : 0;
    
   //לבדוק כמה בחירות היה בסט הנוכחי
    const totalSelected = this.getSelectedCount(parentSet);
    
    if (newCount > 0 && totalSelected >= parentSet.MaxCount) {

        if (parentSet.MaxCount == 1)
        {
          for ( let ingre of parentSet.Ingredients)
          {
              if (ingre.SelectedCount > 0 && ingre.ID != ingredient.ID )
              {
                this.decreaseQuantity(ingre , parentSet)
              }
          }
        }

else
{ return; // אינו יכול לבחור יותר}
     
    }
  }
    
        ingredient.isPressed = true;
        setTimeout(() => ingredient.isPressed = false, 100);
   
  


    if (ingredient.internalSets.length > 0 && ingredient.internalSets[0].MenuID > 0 && newCount > 0) {
      if (ingredient.DealOrderMenu && ingredient.DealOrderMenu.ID > 0) {

     this.openNestedPopup(ingredient, parentSet);
        return;
      }
      // אם יש סט פנימי צריך לשלוח את הפרמטרים של הסט הפנימי
      // ולפתוח את הפופ אפ של הסט הפנימי
       this.orderService.addToBagOrder_(
        ingredient.internalSets[0].MenuID, 
        this.dish?.restaurantID || this.restaurantID,
        //Count
        ingredient.internalSets[0].DealMenu?.CountNumber || 1,
         //this.dish.Rate, 
         this.setsList.OrderListID,
         this.setsList.CountNumber,
         parentSet.ID,
        ingredient.ID,).subscribe((res:any)=>{
            if (res)
            {
           this.openNestedPopup(ingredient, parentSet);
            }
    

       })
       return;
    }
    else if (newCount == 0) {
    }
  ingredient.SelectedCount = newCount;

    //לשלוח לשנות את הכותרת של חובת הבחירה
    this.setTextForRequired(parentSet)

//אם יש סט פנימי צריך שיופיע הכותרת של חובת הבחירה
    if (ingredient.internalSets.length > 0)
    {
      if ( newCount > 0)
      {
        for (let setIngr of ingredient.internalSets )
        {
          this.setTextForRequired(setIngr)
        }
        return
      }
      //למחיקת הסטים הפנימיים
      this.deleteIngreInSetIngre(ingredient.internalSets)
    
    }

  }

  //פונקציה למחיקת הבחירות בסטים פנימיים
  //כאשר מוחקים את תוסף האב
  private deleteIngreInSetIngre(myIngreInSet : Set[])
  {
    for (let setIngr of myIngreInSet)
      {
        const internalSetsSelected = this.getSelectedCount(setIngr);
        if (internalSetsSelected > 0)
        {
          let count = 0
          for ( let ingreInSetIngrediant of setIngr.Ingredients)
            {
                
                if (count >= internalSetsSelected)
                {
                    break
                }
                if (ingreInSetIngrediant.SelectedCount > 0  )
                {
                  count ++
                  this.decreaseQuantity(ingreInSetIngrediant , setIngr)
                  if (ingreInSetIngrediant.internalSets.length > 0)
                  {
                    this.deleteIngreInSetIngre(ingreInSetIngrediant.internalSets)
                  }
                }
                

            }
        }
      }
  }

  //פונקציה לחישוב המחיר 
  private calculateTotalPrice(items: Set[]): number {
    return items.reduce((total, item) => {
        let sum = item.priceToPay || 0;
        
        
        if (item.Ingredients) {
            sum += item.Ingredients.reduce((innerTotal, ingredient) => {
                return innerTotal + this.calculateTotalPrice(ingredient.internalSets || []);
            }, 0);
        }
        
        return total + sum  ;
    }, 0);
}

private setTextForRequired(set: Set) : number   {
    const totalSelected = this.getSelectedCount(set);
   

   
//לצבוע באפור אם מתחיל לסמן
   if( set.ChooseEnough == 'normal')
   {
    // if (totalSelected >= set.RequiredCount)
    // {
      set.ChooseEnough = "ChooseEnough"
    // }
   }
   else{
    set.ChooseEnough = "ChooseEnough"
   }

    if (set.IsFreeShow ||this.privateIsFromEdit) {
        this.calculateSetPrice(set , totalSelected);
       
    }

    this.myTotalPrice = this.calculateTotalPrice(this.setsList.list) + Number(this.dish?.Price ? this.dish.Price : this.ingredientPrice || 0);
   // this.myTotalPrice += Number(this.dish.Price)
      this.totalPrice = this.formatPrice(Number(this.myTotalPrice * this.countDish));
      set.IsFreeShow = true;



         //חינם
    if (set.FreeCount > 0 )
    {
      set.isGreenFree = false
      set.IsFreeShow = false
      if (set.FreeCount > totalSelected) 
      {
        if (totalSelected == 0)
          {
            set.TextForRequired  =  `מקבלים ${set.FreeCount} חינם `
           
          }
           else 
           {
            set.TextForRequired = `אפשר לבחור עוד ${set.FreeCount - totalSelected} חינם `
           }
           set.isGreenFree = true
           return totalSelected
        
      }
      else
      {
        set.IsFreeShow = true
        set.isGreenFree = false
      }
    }
    //1. חובת בחירה
    if (set.RequiredCount > 0 && totalSelected < set.RequiredCount)
    {
      // set.IsFreeShow = false
      if (totalSelected == 0)
      {
        set.TextForRequired = "חובה לבחור לפחות " + set.RequiredCount
      }
       else 
       {
        set.TextForRequired = "חובה לבחור עוד " + (set.RequiredCount - totalSelected)
       }

       return  totalSelected
    }
 
    if (set.MaxCount > totalSelected)
    {
    
        if ((set.MaxCount - totalSelected) == 1)
        {
          set.TextForRequired = totalSelected == 0?`אפשר לבחור פריט ${set.MaxCount - totalSelected}`: `אפשר לבחור עוד ${set.MaxCount - totalSelected}`
        }
        else
        {
          set.TextForRequired = totalSelected == 0?`אפשר לבחור ${set.MaxCount - totalSelected} פריטים`: `אפשר לבחור עוד ${set.MaxCount - totalSelected} פריטים`
        }
        
    }
    else
    {
      set.TextForRequired = "הגעת למקסימום" 
    }
    return totalSelected 
  }

  private getSelectedCount(set: Set): number {
    return set.Ingredients.reduce((total, ing) => total + (ing.SelectedCount || 0), 0);
  }



private calculateSetPrice(mySet: Set, count: number): void {

 
  // הפונקציה בודקת את הסכום של התוספות שאינם חינם 
  // אלו עם התשלום הגבוה
  const setcopy: Ingredient[] = [];
  
  
  mySet.Ingredients.forEach(ingredient => {
    if (ingredient.SelectedCount > 0) {
      for (let i = 0; i < ingredient.SelectedCount; i++) {
        setcopy.push(ingredient);
      }
    }
  });

 
  setcopy.sort((a: Ingredient, b: Ingredient) => 
    Number(a.Price)- Number(b.Price)
  );

  const itemsToPay = count - mySet.FreeCount;
  
  
  if (itemsToPay <= 0) {
    mySet.priceToPay = 0;
    return;
  }

  
  const totalPrice = setcopy
    .slice(-itemsToPay) 
    .reduce((sum, ingredient) => {
      const price = Number(ingredient.Price);
      const dealOrderMenuPrice = ingredient.DealOrderMenu !== null ? Number(ingredient.DealOrderMenu.IngredientsPrice) : 0;
      return sum + price + dealOrderMenuPrice;
    }, 0);

  mySet.priceToPay = totalPrice;
}

//פלוס
  increaseQuantity(ingredient: Ingredient, parentSet: Set) {
    ingredient.isPressed = true, setTimeout(() => ingredient.isPressed = false, 100)
    const totalSelected = this.getSelectedCount(parentSet);
    if (totalSelected < parentSet.MaxCount) {
      ingredient.SelectedCount = (ingredient.SelectedCount || 0) + 1;
      this.setTextForRequired(parentSet)
    }

    if (ingredient.internalSets.length > 0)
    {
      for (let setIngr of ingredient.internalSets )
      {
        this.setTextForRequired(setIngr)
      }
    }
  }
//מינוס
  decreaseQuantity(ingredient: Ingredient , parentSet: Set ,isfromUI = false) {
    isfromUI && (ingredient.isPressed = true, setTimeout(() => ingredient.isPressed = false, 100))
    if (ingredient.SelectedCount > 0) {
      ingredient.SelectedCount--;
      this.setTextForRequired(parentSet)
      if (ingredient.internalSets.length > 0)
        {
          this.deleteIngreInSetIngre(ingredient.internalSets)
        }
    }
  }

  // toggleSubIngredient(subIngredient: Ingredient, parentSet: Set) {
  //   const currentCount = subIngredient.SelectedCount || 0;
  //   const newCount = currentCount === 0 ? 1 : 0;
    
  //   const totalSelected = parentSet.Ingredients.reduce(
  //     (total, ing) => total + (ing.SelectedCount || 0),
  //     0
  //   );
    
  //   if (newCount > 0 && totalSelected >= parentSet.MaxCount) {
  //     return;
  //   }
    
  //   if (newCount === 0 && totalSelected <= parentSet.RequiredCount) {
  //     return;
  //   }
    
  //   subIngredient.SelectedCount = newCount;
  // }
  // פונקציה לעיצוב המחיר   
  private formatPrice(amount: number): string {
    const rounded = Math.round((amount + Number.EPSILON) * 100) / 100;
    return Number.isInteger(rounded) ? `₪${rounded.toFixed(0)}` : `₪${rounded.toFixed(2)}`;
  }

//פונקציה לבדוק אם בחרו מספיק
  private chekIsEnough(mySet? : Set[] ):boolean
    {
       if (!mySet && (!this.setsList || !this.setsList.list || this.setsList.list.length === 0)) {
         return true;
       }

    let mineSet =  mySet ? mySet : this.setsList.list
    let isCanSave = true
    let isFirstSet : Set = null
  
    for (let set of mineSet)
    {
   
      if (set.IsRequired)
      {
 
      if (this.getSelectedCount(set) < set.RequiredCount)
      {
        if (this.getSelectedCount(set) == 0)
      {
        set.TextForRequired = "חובה לבחור לפחות " + set.RequiredCount
      }
       else 
       {
        set.TextForRequired = "חובה לבחור עוד " + (set.RequiredCount - this.getSelectedCount(set))
       }
        setTimeout(() => {
          set.ChooseEnough = 'normal';
          
        }, 40); 
           
        this.triggerShakeAnimation(set)
        isCanSave = false

        if (!isFirstSet)
        {
          isFirstSet = set
        }
      }
      }
      
      for (let ingredient of set.Ingredients)
      {
        if (ingredient.SelectedCount > 0)
          {
        if (ingredient.internalSets.length > 0 )
        {
         isCanSave = isCanSave && this.chekIsEnough(ingredient.internalSets)
        }
          }
    }
    }
    if (isFirstSet)
      {
        this.scrollTo('startSet' + isFirstSet.ID)
      }
      return isCanSave
    }



    private saveSetb(mySet: Set[]): SetsSave[] {
      if (!mySet || mySet.length === 0) {
        return [new SetsSaveClass()];
      }
    
      const mySaveSets: SetsSaveClass[] = [];
    
      for (const set of mySet) {
        if (this.getSelectedCount(set) <= 0) {
          continue;
        }
    
        const mySaveSet = new SetsSaveClass();
        mySaveSet.ID = set.ID;
        mySaveSet.Ingredients = [];
    
        for (const ingredient of set.Ingredients) {
          for (let i = 0; i < ingredient.SelectedCount; i++) {
            const myIngredient = new IngredientSaveClass();
            myIngredient.ID = ingredient.ID;
            
            if (ingredient.internalSets?.length > 0) {
              myIngredient.Sets = this.saveSetb(ingredient.internalSets);
            } else {
              myIngredient.Sets = [new SetsSaveClass()];
            }
    
            mySaveSet.Ingredients.push(myIngredient);
          }
        }
    
        mySaveSets.push(mySaveSet);
      }
    
      return mySaveSets.length > 0 ? mySaveSets : [new SetsSaveClass()];
    }
   
     async saveSetClick()
  {


     //שלב 1. לבדוק ולסמן מה שלא בחרו מספיק
    if (this.chekIsEnough())
    {
      if (this.setsList && this.setsList.list && this.setsList.list.length > 0)
      {
      //שלב 2. אם מסומן מספיק להמיר את הבחורים לאוביקט של השמירה
      this.setsSave = this.saveSetb(this.setsList.list)
      console.log( this.setsSave)
      //שלב 3. לבדוק מה בחור ואפשר למחוק את הסטים הפנימיים שלא נבחרו
      this.deletedNestedMenus = this.deleteNested(this.setsList.list)
      //שלב 4. לשלוח לשמירה
      }
      try {
        let isSave = await this.orderService
           .addOrderIngredient(this.setsList.OrderListID, this.setsSave,this.setsList.CountNumber ,this.setsList.DinerName,this.setsList.Comments,this.countDish ,this.deletedNestedMenus)
           .toPromise();
           
    

            //לשלוח לשמירה ואם זה מצליח לסגור את הפופ אפ

            if (isSave)
            {
               this.saveSet.emit();
            }
           
       } catch (error) {
         console.error('Error loading sets:', error);
         // Handle error appropriately
       }

    }

  }

  //להרעיד את הכותרת של הסט שלא נבחר הכל

  triggerShakeAnimation(set : Set) {

  
    set.ChooseEnough = 'shake';
    setTimeout(() => {
      set.ChooseEnough = 'normal';
      
    }, 500); 

   
  }

  scrollTo(idName: string): void {
    const overlay = this.popupOverlayRef?.nativeElement;
    const nameLine = this.nameLineRef?.nativeElement;
    const element = overlay?.querySelector('#' + idName);
    if (overlay && nameLine && element) {
      overlay.scrollTo({
        top: element.offsetTop - nameLine.offsetHeight,
        behavior: 'smooth'
      });
    }
  }

  closeInfo(event: any )
  {
    if (event.target.name  =='infoButton')
    {
      return
    }
    if (this.infoId > 0  )
      {
          var x4 = document.getElementById("infoSideDiv"+this.lastParentSetID+this.infoId);
        
         x4.style.display = "none";
        
        
    this.infoId = 0
    this.lastParentSetID = 0
  }
  }

  hasInlineSpace = null;
  private checkAvailableSpace(balloonWidth : number , sideWidth: number) : boolean {
  
    console.log("Width:" + sideWidth)
    console.log("balloWidth:" + balloonWidth)
    // Check if there's enough space to the right
     return (sideWidth) >= (balloonWidth + 30); // 20px buffer
  }


showInfo(ingredient: Ingredient, parentSetID: number) {
  // Close previous balloon if open
  if (this.infoId > 0 && (this.infoId !== ingredient.ID || parentSetID !== this.lastParentSetID)) {
    const prev = document.getElementById("infoSideDiv" + this.lastParentSetID + this.infoId);
    if (prev) prev.style.display = "none";
  }

  const element = document.getElementById("spaceElement" + parentSetID + ingredient.ID);
  const infoSideForDesign = document.getElementById("infoSideForDesign" + parentSetID + ingredient.ID);
  const x = document.getElementById("infoSideDiv" + parentSetID + ingredient.ID);

  if (x.style.display === "none") {
    this.hasInlineSpace = null;
    setTimeout(() => {
      this.hasInlineSpace = this.checkAvailableSpace(infoSideForDesign.offsetWidth, element.offsetWidth);
      x.style.display = "block";
    }, 0);
  } else {
    x.style.display = "none";
  }

  this.infoId = ingredient.ID;
  this.lastParentSetID = parentSetID;
}

  //הכנה לפונקצית מחיקה של המנות הפנימיות שנשמרו
deleteNested(sets: Set[]): DeletedInnerMenus[] {
  if (!sets) return [];
  return [].concat(
    ...sets.map(set =>
      set.Ingredients
        .filter(ingredient =>
          ingredient.SelectedCount === 0 &&
          ingredient.DealOrderMenu &&
          ingredient.DealOrderMenu.ID > 0
        )
        .map(ingredient => ({
          OrderListID: ingredient.DealOrderMenu.ID,
          CountNumber: ingredient.DealOrderMenu.Count
        }))
    )
  );
}


  onNestedClose() {
  
  if (this.nestedPopupParams) {
    const parentSet = this.setsList.list.find(set => set.ID === this.nestedPopupParams.dishSetID);
    if (parentSet) {
      const ingredient = parentSet.Ingredients.find(ing => ing.ID === this.nestedPopupParams.ingredientID);
      if (ingredient &&  ingredient.SelectedCount == 0 && (!this.isChangeOnFood|| ingredient.DealOrderMenu && ingredient.DealOrderMenu.listSets.length == 0)) {
        this.orderService.DeleteDealMenu(
          this.setsList.OrderID,
          this.nestedPopupParams.parentOrderListID,
          this.nestedPopupParams.parentCountNumber,
          this.nestedPopupParams.dishSetID,
          this.nestedPopupParams.ingredientID
        ).subscribe( () => {
          ingredient.SelectedCount = 0;
        this.setTextForRequired(parentSet)
        this.nestedPopupOpen = false;
         this.nestedPopupParams = null;
        }
        )
        
      }
      else if (ingredient) {
         if (ingredient.SelectedCount == 0 &&  ingredient.DealOrderMenu.listSets.length == 0)
         {
        ingredient.totalPrice = 0;
        ingredient.SelectedCount = 0;
        //לשלוח לשנות את הכותרת של חובת הבחירה
        this.setTextForRequired(parentSet)
         this.nestedPopupParams = null;
         }
        
          this.nestedPopupOpen = false;
         
      }
    }
    else
    {
      this.nestedPopupOpen = false;
      this.nestedPopupParams = null;
    }
  }
 
}

  async onNestedSaveSet() {
   this.nestedPopupOpen = false;
  if (this.nestedPopupParams) {
    const result = await this.orderService.GetInnerDealDetails(
      this.nestedPopupParams.parentOrderListID,
      this.nestedPopupParams.parentCountNumber,
      this.nestedPopupParams.dishSetID,
      this.nestedPopupParams.ingredientID
    ).toPromise();

    // Find parent set and ingredient
    const parentSet = this.setsList.list.find(set => set.ID === this.nestedPopupParams.dishSetID);
    if (parentSet) {
      const ingredient = parentSet.Ingredients.find(ing => ing.ID === this.nestedPopupParams.ingredientID);
      if (ingredient && result) {
        //selectedcount
        
        ingredient.DealOrderMenu = result;
        ingredient.totalPrice = result.IngredientsPrice ;
        ingredient.SelectedCount = 1; 
        this.setTextForRequired(parentSet);
      }
    }
    this.nestedPopupParams = null;
    


  }
  
  
}
getAllIngredientNames(listSets: Set[]): string[] {
  let names: string[] = [];
  if (!listSets) return names;
  for (const set of listSets) {
    if (set.Ingredients) {
      for (const ing of set.Ingredients) {
        if (ing.IngredientName) {
          names.push(ing.SelectedCount > 1 ? `${ing.IngredientName} X${ing.SelectedCount}` : ing.IngredientName);
        }
        // Recursively add names from internalSets
        if (ing.internalSets && ing.internalSets.length > 0) {
          names.push(...this.getAllIngredientNames(ing.internalSets));
        }
      }
    }
  }
  return names;
}
//_______________________
//footer to ios  and android devices
//_______________________


private isIOS: boolean = false;
private isAndroid: boolean = false;
private safeAreaBottom: number = 0;


  private detectIOSAndSetupSafeArea() {
    // Detect iOS
    this.isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) || 
                 (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

    this.isAndroid = /Android/.test(navigator.userAgent);

    if (this.isIOS || this.isAndroid) {
      this.setupSafeArea();
    }
  }

  private setupSafeArea() {
    this.safeAreaBottom = this.getSafeAreaInsetBottom();
    document.documentElement.style.setProperty('--safe-area-bottom', `${this.safeAreaBottom}px`);

    if (this.isIOS) {
      document.body.classList.add('ios-device');
    } else if (this.isAndroid) {
      document.body.classList.add('android-device');
    }
  }

  private getSafeAreaInsetBottom(): number {
    // Try to get safe area from CSS first
    const testElement = document.createElement('div');
    testElement.style.position = 'fixed';
    testElement.style.bottom = '0';
    testElement.style.paddingBottom = 'env(safe-area-inset-bottom)';
    testElement.style.visibility = 'hidden';
    document.body.appendChild(testElement);

    const computedStyle = window.getComputedStyle(testElement);
    const paddingBottom = parseFloat(computedStyle.paddingBottom);

    document.body.removeChild(testElement);

    // Fallback calculation for older iOS or Android with overlays
    if (paddingBottom === 0 && (this.isIOS || this.isAndroid)) {
      return this.calculateBottomSafeArea();
    }

    return paddingBottom;
  }

  private calculateBottomSafeArea(): number {
    const screenHeight = window.screen.height;
    const windowHeight = window.innerHeight;
    const heightDifference = screenHeight - windowHeight;
    // For iOS
    if (this.isIOS) {
        const visual = (window as any).visualViewport;
      if (visual && typeof visual.height === 'number') {
        const visualDiff = screenHeight * 0.09 - (visual.height + (visual.offsetTop || 0));
        if (visualDiff > 10) {
          return Math.round(visualDiff);
        }
      }
      if (heightDifference > 150) return 68; // iPhone X and newer
 
      return 0;
    }
   if (this.isAndroid) {
    // Treat very large differences as browser chrome, not navigation bar
    if (heightDifference > 90 && heightDifference < 300) {
      if (heightDifference < 158) return 50; // Small nav bar
      if (heightDifference < 200) return 80; // Medium nav bar
      if (heightDifference < 250) return 120; // Large nav bar
      return 150; // Very large nav bar
    }
    // If the difference is too large, it's probably browser chrome
    return 0;
  }
  return 0;
}

  private setupViewportListener() {
    let resizeTimer: any;

    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        this.updateSafeAreaOnResize();
      }, 100);
    });

    window.addEventListener('orientationchange', () => {
      setTimeout(() => {
        this.updateSafeAreaOnResize();
      }, 500);
    });
  }

  private updateSafeAreaOnResize() {
    if (this.isIOS || this.isAndroid) {
      const newSafeAreaBottom = this.getSafeAreaInsetBottom();
      this.safeAreaBottom = newSafeAreaBottom;
      // document.documentElement.style.setProperty('--safe-area-bottom', `${newSafeAreaBottom}px`);
    }
  } 
 } 